import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { isInlineEmbedSelector } from 'selectors/embed'

const setInlineEmbedStyles = () => {
  document.body.style.minHeight = 'auto'
  document.body.style.height = 'auto'
  document.documentElement.style.height = 'auto'
}

export const EmbedResizeMessager = ({ children }) => {
  const mainContainer = useRef(null)
  const isInlineEmbed = useSelector(isInlineEmbedSelector)

  useEffect(() => {
    if (!mainContainer?.current || !isInlineEmbed) return undefined

    setInlineEmbedStyles()
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach(() => {
        const payload = { height: `${document.body.scrollHeight + 2}px` }
        const message = { event: 'calendly.page_height', payload }
        window.parent.postMessage(message, '*')
      })
    })
    resizeObserver.observe(mainContainer.current)
    return () => { resizeObserver.disconnect() }
  }, [isInlineEmbed])

  return (<div ref={mainContainer}>{children}</div>)
}
